import { Prop } from '@typegoose/typegoose'
import { Field, InputType, ObjectType } from 'type-graphql'

@ObjectType()
@InputType('LoginTokenInput')
export class LoginToken {
  @Field(() => String)
  @Prop({ type: String })
  hashedToken: string

  @Field(() => Date)
  @Prop({ type: Date })
  when: Date

  @Field(() => String)
  @Prop({ type: String })
  name?: string

  @Field(() => String)
  @Prop({ type: String })
  scope?: string
}
